import { NgModule } from "@angular/core";
import { UiModule } from "@webapp/ui/ui.module";
import { RelatedItemsComponent } from "./related-items/related-items.component";

@NgModule({
  imports: [UiModule],
  declarations: [RelatedItemsComponent],
  providers: [],
})
export class LinksModule {}
